﻿import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Loader from 'react-loader';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import { handleError } from '../../../shared/ErrorCatching';
import * as actions from '../OrdersActions';
import { IUnBookedOrderListItem } from '../Entities';
import FormSelect from '../../../components/common/FormSelect';
import AutoUpdateListTrigger from '../../../shared/AutoUpdateListTrigger';
import FormInputChangeHandler from './../../../shared/form/FormInputChangeHandler';
import UnBookedOrderList from './UnBookedOrderList';

class UnBookedOrdersPage extends React.Component<any, any> {
    private _updateListTrigger: AutoUpdateListTrigger;
    formInputChangeHandler: FormInputChangeHandler;

    constructor(props: any, context: any) {
        super(props, context);
        this.state = {
            filters: {
                region: -1
            },
            isLoading: false
        };

        this.getOrders = this.getOrders.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.navigateTo = this.navigateTo.bind(this);
        this.setValue = this.setValue.bind(this);

        this._updateListTrigger = new AutoUpdateListTrigger(this.getOrders);
    }

    setValue(newState: any) {
        this.setState({ filters: newState });
    }

    UNSAFE_componentWillMount(): void {
        this.formInputChangeHandler = new FormInputChangeHandler(this.state.filters, this.setValue);
        this.getOrders();
        this._updateListTrigger.subscribe();
    }

    componentWillUnmount() {
        this._updateListTrigger.unsubscribe();
    }

    getOrders() {
        if (!this.state.isLoading) {
            this.setState({ isLoading: true });
            this.props.actions
                .getOrders()
                .then(() => {
                    this.setState({ isLoading: false });
                })
                .catch((error: any) => {
                    this.setState({ isLoading: false });
                    return handleError(error);
                });
        }
    }

    render() {
        let orders: IUnBookedOrderListItem[] = [];
        if (this.props.orders) {
            orders = this.props.orders;
        }

        let filters = this.state.filters;

        if (filters.region !== -1) {
            orders = orders.filter((x) => x.regionId.toString() === filters.region.toString());
        }

        return (
            <div>
                <h1>
                    {Translate('orders/title/bookings')}{' '}
                    {!this.state.isLoading && (
                        <span className="number-of-orders">({orders.length})</span>
                    )}
                </h1>
                <div className="col-md-3">
                    <FormGroup>
                        <ControlLabel>
                            {Translate('orders/list/bookings/header/regions')}
                        </ControlLabel>
                        <FormSelect
                            name="region"
                            data-testid="filter-region"
                            value={this.state.filters.region}
                            onChange={this.formInputChangeHandler.onChange}
                        >
                            <option value="-1">
                                {Translate('orders/list/bookings/select-label/filter')}
                            </option>
                            {this.props.regions &&
                                this.props.regions.map((t: any) => {
                                    return (
                                        <option key={t.id} value={t.id}>
                                            {t.name}
                                        </option>
                                    );
                                })}
                        </FormSelect>
                    </FormGroup>
                </div>
                <Loader loaded={!this.state.isLoading}>
                    <UnBookedOrderList
                        items={orders}
                        user={this.props.user}
                        navigateTo={this.navigateTo}
                    />
                </Loader>
            </div>
        );
    }

    closeModal() {
        this.setState({ showModal: false, selectedOrderId: null });
    }

    navigateTo(route: string) {
        this.props.history.push(route);
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        orders: state.orders.photoOrders.list,
        regions: state.orders.photoOrders.regions,
        user: state.user
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getOrders: () => dispatch(actions.getUnBookedOrders())
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UnBookedOrdersPage));
